module.exports = __webpack_public_path__ + "img/4.31b301ea.jpg";